import { Oval } from "react-loader-spinner";

import { useTypedSelector } from "../../../store/store";

interface ILoadingIndicatorProps {
  width?: number;
  height?: number;
  color?: string;
  secondaryColor?: string;
  strokeWidth?: number;
  strokeWidthSecondary?: number;
  className?: string;
}

function LoadingIndicator({
  width = 40,
  height = 40,
  strokeWidth = 8,
  strokeWidthSecondary = 4,
  className = "",
}: ILoadingIndicatorProps) {
  const { primary_color } = useTypedSelector((state) => state.environment);

  return (
    <Oval
      ariaLabel="oval-loading"
      width={width}
      height={height}
      color={primary_color || "#000000"}
      secondaryColor={primary_color || "#000000"}
      strokeWidth={strokeWidth}
      strokeWidthSecondary={strokeWidthSecondary}
      wrapperClass={className}
    />
  );
}

export default LoadingIndicator;
